export default __webpack_public_path__ + "static/media/icon-edit.69f457eb.svg";